/**
 * Wishlist heart button behavior.
 * Talks to the existing Einstein backend /saved-items API through the
 * Shopify App Proxy at /apps/einstein/saved-items. No separate app login -
 * relies entirely on the logged-in Shopify customer session.
 */
(function () {
  var ENDPOINT = '/apps/einstein/saved-items';
  var wishlistState = new Set();
  var stateLoaded = false;

  function isLoggedIn() {
    return window.ShopifyCustomerLoggedIn === true;
  }

  function setButtonState(btn, saved) {
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
  }

  function updateAllButtons() {
    document.querySelectorAll('[data-wishlist-heart]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      setButtonState(btn, wishlistState.has(id));
    });
  }

  function loadWishlistState() {
    if (!isLoggedIn() || stateLoaded) return;

    fetch(ENDPOINT, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to load wishlist state');
        return res.json();
      })
      .then(function (data) {
        var items = Array.isArray(data) ? data : data.items || [];
        items.forEach(function (item) {
          if (item.state && item.state !== 'wishlist') return;
          var id = item.item_id || item.product_id || item.id;
          if (id != null) wishlistState.add(String(id));
        });
        stateLoaded = true;
        updateAllButtons();
      })
      .catch(function (err) {
        console.error('[wishlist] failed to load state', err);
      });
  }

  function toggleWishlist(btn) {
    var id = btn.getAttribute('data-product-id');
    if (!id) return;

    if (!isLoggedIn()) {
      window.location.href =
        '/account/login?return_url=' + encodeURIComponent(window.location.pathname);
      return;
    }

    var currentlySaved = wishlistState.has(id);
    // Optimistic UI update so the heart responds instantly.
    setButtonState(btn, !currentlySaved);
    btn.disabled = true;

    var request = currentlySaved
      ? fetch(ENDPOINT + '/' + id, { method: 'DELETE', credentials: 'same-origin' })
      : fetch(ENDPOINT, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ item_id: id, state: 'wishlist' }),
        });

    request
      .then(function (res) {
        if (!res.ok) {
          return res.text().then(function (bodyText) {
            throw new Error('HTTP ' + res.status + ' - ' + bodyText.slice(0, 300));
          });
        }
        if (currentlySaved) {
          wishlistState.delete(id);
        } else {
          wishlistState.add(id);
        }
      })
      .catch(function (err) {
        console.error('[wishlist] toggle failed', err);
        // Revert the optimistic update if the request failed.
        setButtonState(btn, currentlySaved);
      })
      .finally(function () {
        btn.disabled = false;
      });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-wishlist-heart]');
    if (!btn) return;
    event.preventDefault();
    toggleWishlist(btn);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadWishlistState);
  } else {
    loadWishlistState();
  }
})();
